import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import LineIcon from '@/components/common/LineIcon.vue'
import { BRAND_COLORS } from '@/config/appBrand'

Vue.use(Vuetify);

export default new Vuetify({
    icons:{
      values: {
        LineIcon: {
          component: LineIcon,
        },
      }
    },
    theme: {
        themes: {
          light: {
            primary: BRAND_COLORS.primary,
            secondary: BRAND_COLORS.secondary,
            appBar: BRAND_COLORS.appBar,
            background: BRAND_COLORS.background,
            surface: BRAND_COLORS.surface,
            error: BRAND_COLORS.error,
            success: BRAND_COLORS.success,
            info: BRAND_COLORS.info,
            warning: BRAND_COLORS.warning,
            anchor: BRAND_COLORS.primary,
          },
        },
        options: {
          cspNonce: 'dQw4w9WgXcQ'
        }
      },
});
